const INDEX_URL = 'index.html';
const LAST_MODIFIED_KEY = 'FYGR_LAST_MODIFIED';
const RELOAD_NOTIFY = 'FYGR_SHOW_RELOAD_NOTIFY';
const ETAG_KEY = 'FYGR_APP_ETAG';
const RESTRICTED_ROUTE_NAMES = ['callback', 'acceptInvite', 'personal-infos'];
export const checkUpdatesMixin = {
  data() {
    return {
      showReloadNotification: false,
      envMode: import.meta.env.MODE,
      runningInterval: null,
      updatesCount: 0,
      // change this updateInterval and intervalRetryCount together
      updateInterval: 1000 * 60 * 5, // 5 minutes
      intervalRetryCount: 12 * 10, // after 10 hours token will be dead and user will be forced to signin
    };
  },
  mounted() {
    if (localStorage.getItem(RELOAD_NOTIFY)) {
      setTimeout(() => {
        this.actionAddNotification({
          msg: "L'application a été mise à jour avec succès.",
          color: 'green',
          disappearing: true,
          once: true,
        });
        localStorage.removeItem(RELOAD_NOTIFY);
      }, 1500);
    }
  },
  watch: {
    $route(to, from) {
      if (
        this.envMode !== 'development' &&
        !RESTRICTED_ROUTE_NAMES.includes(from.name) &&
        to.name !== from.name
      ) {
        clearInterval(this.runningInterval);
        this.updatesCount = 0;
        this.startInterval();
        this.checkUpdates(
          !!to.name.includes('signup') || !!to.name.includes('auth'),
        ); // when route changes we can force update without user selection.
        // no force update to signup page to keep connection params
      }
    },
  },
  methods: {
    startInterval() {
      this.runningInterval = setInterval(async () => {
        if (this.updatesCount < this.intervalRetryCount)
          await this.checkUpdates(true);
      }, this.updateInterval);
    },
    showNotification() {
      this.showReloadNotification = true;
    },
    clearCache(showSuccessNotify) {
      if (showSuccessNotify) {
        localStorage.setItem(RELOAD_NOTIFY, 'true');
      }

      if ('caches' in window) {
        caches
          .keys()
          .then((names) => {
            names.forEach((name) => caches.delete(name)); // Clear all caches
          })
          .then(() => {
            // Reload the page after clearing cache
            window.location.reload(true);
          });
      } else {
        window.location.reload(true);
      }
    },
    async checkUpdates(notifyOnly) {
      this.updatesCount++;
      try {
        const response = await fetch(INDEX_URL, {method: 'HEAD'});

        const lastModified = response.headers.get('Last-Modified');
        const eTag = response.headers.get('ETag');
        const storedLastModified = localStorage.getItem(LAST_MODIFIED_KEY);

        if (lastModified && lastModified !== storedLastModified) {
          localStorage.setItem(LAST_MODIFIED_KEY, lastModified);
          if (eTag) {
            // update both params to sync
            localStorage.setItem(ETAG_KEY, eTag);
          }
          if (storedLastModified) {
            notifyOnly ? this.showNotification() : this.clearCache();
          }
        }

        // Alternatively, check for `ETag` changes
        const storedEtag = localStorage.getItem(ETAG_KEY);
        if (!lastModified && eTag && eTag !== storedEtag) {
          localStorage.setItem(ETAG_KEY, eTag);
          if (storedEtag) {
            notifyOnly ? this.showNotification() : this.clearCache();
          }
        }
      } catch (error) {
        console.error('Error checking for updates:', error);
      }
    },
  },
};

export default {checkUpdatesMixin};
